import React, { memo, useContext } from "react";
import { SVGAccidentalSplit} from "../../Util/Music/Accidentals/Accidentals";
import { TransformTranslate } from "../../Util/Transform/Transform";
import { Music } from "../../Util/Music/Music";
import { motion } from "motion/react";
import { ClassNames } from "../../Util/ClassNames";
import { Key } from "../../Data/HexMap/Key";
import { Note } from "../../Data/HexMap/Note";
import DisplayConfig from "../../Data/HexMap/DisplayConfig";
import { DisplayContext } from "./DisplayContext";
export interface KeyCompProps{
    keyData:Key
    onKeyClick:Function
    ctrl?:boolean
}
export const HxKey = memo(function HxKey(props:KeyCompProps){
    const key = props.keyData
    const displayConfig:DisplayConfig = useContext(DisplayContext);
    const tonicName = Music.notes[key.params.tonic]
    const getTransform = () => {
        return TransformTranslate(key.params.x, key.params.y)
    }
    const getPointArray = () => {
        let r:number = displayConfig.keyRadius
        let w:number = r * .866
        let posA:number[] = [0, -1 * r]
        let posB:number[] = [w, -0.5 * r]
        let posC:number[] = [w, 0.5 * r]
        let posD:number[] = [0, r]
        let posE:number[] = [-1 * w, 0.5 * r]
        let posF:number[] = [-1 * w, -0.5 * r]
        return[posA, posB, posC, posD, posE, posF]
    } 
    const getPoints = () => {
        let points:number[][] = getPointArray()
        return [points[0].join(' '), points[1].join(' '), points[2].join(' '), points[3].join(' '), points[4].join(' '), points[5].join(' ')].join(',')
    }
    const onClick = (e:React.MouseEvent)=>{
        props.onKeyClick(props.keyData, e)
    }
    const onCtrl = (e:React.MouseEvent)=>{
        if(props.ctrl){
            e.preventDefault()
            props.onKeyClick(props.keyData, e, true)
        }
    }
    const getLabel = () => {
        const baseFontSize:number = displayConfig.getKeyFontSize()
        if(key.open || !key.defined){return null}
        const getInnerLabel = () => {
            if(key.predefinedLabel !== null){
                const keyCharacters:string[] = key.predefinedLabel.split('')
                if(keyCharacters.length === 2 && (keyCharacters[1] === 'b' || keyCharacters[1] === '#')){
                    return <g dy={'.3em'}><SVGAccidentalSplit baseFontSize={baseFontSize} primaryLabel={key.predefinedLabel} tonic={key.params.tonic}/></g>
                }
                return <g className={'predefined-label'}><text dy={'.3em'} fontSize={baseFontSize}>{key.predefinedLabel}</text></g>
            }
            return <SVGAccidentalSplit baseFontSize={baseFontSize} tonic={key.params.tonic}/>
        }
        const getSecondaryLabel = function(){
            if(props.keyData.secondaryLabel === null || !props.keyData.defined){
                return null
            }
            const translateY:number = Math.floor(baseFontSize * 0.9)
            return <g fontSize={baseFontSize * .65} className='secondary-label' transform={TransformTranslate(0,translateY)}>
                        <text>{props.keyData.secondaryLabel}</text>
                    </g>
        } 
        return <motion.g initial={{scale:0}} 
                    animate={{scale:1}} 
                    transition={{ duration: 1}} 
                    className={getLabelClassNames()}>
                        {getInnerLabel()}
                        {getSecondaryLabel()}
                </motion.g>
    }
    const getComponentClassNames = () => {
        const classNames:ClassNames = new ClassNames(['key-comp'])
        classNames.addClasses(key.classNames)
        classNames.addClass(tonicName)
        classNames.addClasses(getSelectedClasses().classNames) 
        classNames.addClass('key_' + key.params.keyIndex)
        if(key.open){
            classNames.addClass('open')
        }
        return classNames.toString()
    }
    const getSelectedClasses = ():ClassNames => {
        const classNames:ClassNames = new ClassNames()
        switch(key.selectedState){
            case Note.SelectedState_Default: classNames.addClass('default'); break;
            case Note.SelectedState_Selected: classNames.addClass('selected'); break;
            case Note.SelectedState_Hilited: classNames.addClass('hilited'); break;
        }
        classNames.addClasses(key.classNames)
        return classNames     
    }
    const selectedClasses:ClassNames = getSelectedClasses()
    const getLabelClassNames = () => {
        let classNames:ClassNames = new ClassNames(['key-label'])
        classNames.addClasses(selectedClasses.classNames)
        return classNames.toString()
    }
    const getHexagonClassNames = () => {
        let classNames:ClassNames = new ClassNames(['key-hexagon', tonicName])
        classNames.addClasses(selectedClasses.classNames)
        return classNames.toString()
    }
    return  <motion.g initial={{opacity:0}} animate={{opacity:1}} 
                        transition={{ duration: 1}} className={getComponentClassNames()} 
                        transform={getTransform()} onClick={onClick} onContextMenu={onCtrl}>
                <polygon className={getHexagonClassNames()} 
                        points={getPoints()}
                        />
                {getLabel()}
            </motion.g>
})